export const WEEKDAY_KEYS = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
];

export function toggleWeekday(slots, day, defaults = { start_time: '18:00', end_time: '19:00' }) {
    if (slots.some((slot) => slot.day === day)) {
        return slots.filter((slot) => slot.day !== day);
    }
    const template = slots[0] || defaults;
    return [
        ...slots,
        { day, start_time: template.start_time, end_time: template.end_time },
    ];
}

export function addDaySlot(slots, day) {
    const existing = [...slots].reverse().find((slot) => slot.day === day);
    return [
        ...slots,
        {
            day,
            start_time: existing?.start_time || '18:00',
            end_time: existing?.end_time || '19:00',
        },
    ];
}

export function updateSlot(slots, index, field, value) {
    return slots.map((slot, slotIndex) =>
        slotIndex === index ? { ...slot, [field]: value } : slot
    );
}

export function removeSlot(slots, index) {
    return slots.filter((_, slotIndex) => slotIndex !== index);
}

export function copyTimeFrom(slots, source) {
    return slots.map((slot) => (
        slot.day === source.day
            ? slot
            : { ...slot, start_time: source.start_time, end_time: source.end_time }
    ));
}

export function validateDaySchedules(slots) {
    if (!slots.length) return 'empty';
    for (const slot of slots) {
        if (!slot.start_time || !slot.end_time || slot.end_time <= slot.start_time) {
            return 'time';
        }
    }
    return null;
}

export function sortScheduleSlots(slots) {
    return slots
        .map((slot, index) => ({ slot, index }))
        .sort((a, b) => {
            const day = WEEKDAY_KEYS.indexOf(a.slot.day) - WEEKDAY_KEYS.indexOf(b.slot.day);
            if (day !== 0) return day;
            return String(a.slot.start_time).localeCompare(String(b.slot.start_time));
        });
}

export function describeStoredRecurrenceDays(entries, labelOf) {
    if (!Array.isArray(entries) || entries.length === 0) return '';
    const parts = entries.map((entry) => {
        const dayKey = typeof entry === 'string' ? entry : entry?.day;
        const label = labelOf(dayKey) || dayKey || '';
        if (entry && typeof entry === 'object' && entry.start_time && entry.end_time) {
            return {
                label,
                time: `${String(entry.start_time).slice(0, 5)}–${String(entry.end_time).slice(0, 5)}`,
            };
        }
        return { label, time: '' };
    });
    const times = new Set(parts.map((part) => part.time).filter(Boolean));
    if (times.size > 1) {
        return parts
            .map((part) => (part.time ? `${part.label} ${part.time}` : part.label))
            .join(', ');
    }
    return parts.map((part) => part.label).filter(Boolean).join(', ');
}
